exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j-area-linkage[data-v-7d6a815f] {\n  height: 40px;\n}\n.j-area-linkage[data-v-7d6a815f] .area-cascader-wrap .area-select {\n  width: 100%;\n}\n.j-area-linkage[data-v-7d6a815f] .area-select .area-selected-trigger {\n  line-height: 1.15;\n}\n", ""]);

// exports
